import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ResetPassword from "./pages/ResetPassword";
import MainLayout from "./layouts/MainLayout";

// Configura la URL base para todas las peticiones de Axios.
// Esto asegura que las peticiones relativas (ej. '/login') apunten a '/api/login'.
axios.defaults.baseURL = '/api';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("token");
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  // Los interceptores para 'fetch' y 'axios' han sido eliminados para simplificar.
  // Se debe asegurar que todas las llamadas a la API se hagan con rutas relativas
  // (ej. axios.get('/usuarios')) para que 'baseURL' funcione correctamente.

  return (
    <BrowserRouter>
      <Routes>
        {/* Rutas públicas */}
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Rutas privadas */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          {/* 🔹 dashboard contendrá subrutas */}
          <Route path="dashboard/*" element={<Dashboard />} />
        </Route>

        {/* Redirección por defecto */}
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;